import { useState } from 'react'
import type { TaskStatus, Task } from '../lib/api'
import TaskCard from './TaskCard'

interface ColumnProps {
  status: TaskStatus
  label: string
  accent: string
  tasks: Task[]
  draggedTaskId: number | null
  onDropTask: (status: TaskStatus, index: number) => void
  onDeleteTask: (id: number) => void
  onDragStartTask: (id: number) => void
}

export default function Column({
  status,
  label,
  accent,
  tasks,
  draggedTaskId,
  onDropTask,
  onDeleteTask,
  onDragStartTask,
}: ColumnProps) {
  const [overIndex, setOverIndex] = useState<number | null>(null)

  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault()
  }

  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault()
    const idx = overIndex ?? tasks.length
    onDropTask(status, idx)
    setOverIndex(null)
  }

  return (
    <div
      className="flex flex-col w-72 shrink-0 bg-kanban-column rounded-xl max-h-full"
      onDragOver={handleDragOver}
      onDrop={handleDrop}
    >
      <div className="flex items-center gap-2 px-4 py-3">
        <span className="h-3 w-3 rounded-full shrink-0" style={{ backgroundColor: accent }} />
        <h2 className="font-semibold text-sm text-text-primary">{label}</h2>
        <span className="ml-auto text-xs text-text-muted font-medium">{tasks.length}</span>
      </div>
      <div className="flex-1 px-2 pb-2 space-y-2 min-h-[140px] overflow-y-auto">
        {tasks.map((task, index) => (
          <TaskCard
            key={task.id}
            task={task}
            isDragging={draggedTaskId === task.id}
            onDragStart={onDragStartTask}
            onDelete={onDeleteTask}
            onDragOver={() => setOverIndex(index)}
          />
        ))}
        {tasks.length === 0 && (
          <div className="text-xs text-text-muted text-center py-8">Déposez une tâche ici</div>
        )}
      </div>
    </div>
  )
}
